import moment from "moment";
import numeral from "numeral";
import _isNull from "lodash/isNull"
import _isUndefined from "lodash/isUndefined"
import _isArray from "lodash/isArray"
import _isBoolean from "lodash/isBoolean"
import _join from "lodash/join"
import _map from "lodash/map"
import _trim from "lodash/trim"
import _floor from "lodash/floor"
import {mapGetters} from "vuex";

export default {
  mounted () {
    this.setMetaData()
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    label () {
      const { type, name } = this.$options;
      return (key, params) => {
        return this.$t(`${type}s.${name}.labels.${key}`, params)
      }
    },
    error () {
      const { type, name } = this.$options;
      return (key, params) => {
        return this.$t(`${type}s.${name}.errors.${key}`, params)
      }
    },
    constsToText () {
      return (value, items) => {
        if (_isNull(value) || _isUndefined(value) || _isNull(items) || _isUndefined(items)) {
          return ""
        }
        if (_isArray(value)) {
          return _join(_map(value, val => {
            const item = items.find(item => item.value === val)
            if (item) {
              return item.label
            }
            return undefined
          }).filter(label => label !== undefined), ", ")
        } else if (_isBoolean(value)) {
          return items.filter(item => item.value === (value ? 1 : 2))[0].label
        } else {
          const selectedItem = items.filter(item => item.value === value);
          if (selectedItem.length > 0) {
            return selectedItem[0].label;
          }
          return "";
        }
      }
    },
    experiencedDomains() {
      if (this.consts) {
        return this.consts.userDomain || []
      }
      return []
    },
    experiencedTools() {
      if (this.consts) {
        return this.consts.userServiceAndTool || []
      }
      return []
    },
  },
  filters: {
    addComma (value) {
      if (value != null) {
        return value.toLocaleString();
      }
    },
    trim: function (value) {
      return _trim(value)
    },
  },
  methods: {
    setMetaData () {
      const { type, name } = this.$options;
      if (type === "page") {
        const title = this.pageTitle() || this.$t(`pages.${name}.title`);
        if (title) {
          document.title = `Nishika Connect - ${title}`;
        }

        const url = this.pageUrl() || "https://connect.nishika.com";
        if (url) {
          document.querySelector("link[rel='canonical']").setAttribute("href", url);
        }
      }
    },
    pageUrl() {
      return null;
    },
    pageTitle() {
      return null;
    },
    go (path) {
      this.$router.push(path);
    },
    back () {
      if(window.history.length > 1){
        this.$router.go(-1);
      } else {
        this.$route.path.indexOf('/clients') == 0 ? this.$router.push('/clients') : this.$router.push('/')
      }
    },
    toNishika (path) {
      return process.env.VUE_APP_NISHIKA_URL+path;
    },
    toProfile (path) {
      return process.env.VUE_APP_NISHIKA_PROFILE_URL+path;
    },
    dateToText (date) {
      if (!date) {
        return "";
      }
      const format = this.$t(`commons.labels.dateFormat`);
      return moment(date, "YYYY/MM/DD").format(format);
    },
    dateToYearMonthText (date) {
      if (!date) {
        return "";
      }
      const format = this.$t(`commons.labels.dateYearMonthFormat`);
      return moment(date, "YYYY/MM/DD").format(format);
    },
    dateTimeToText (date) {
      if (!date) {
        return "";
      }
      const format = this.$t(`commons.labels.dateTimeFormat`);
      return moment(date, "YYYY/MM/DD HH:mm").format(format);
    },
    toDaysAfter (date) {
      return moment(date, "YYYY/MM/DD").diff(moment(), "days");
    },
    fromNow (date) {
      return moment(date).locale(this.$i18n.locale).fromNow();
    },
    toRemainingDays (date, validDays=14) {
      // 有効期限は当日を含むため、+1日する
      const expiredDate = moment(date).add(validDays + 1, "days");
      return `残り${this.toDaysAfter(expiredDate)}日`;
    },
    age (birthday) {
      if (birthday) {
        return -moment(birthday).diff(moment(), "years");
      }
      return undefined
    },
    sizeToText (biteSize) {
      const units = ["bites", "KB", "MB"];
      const sizeToText = (size, units) => {
        if (size < 1024 || units.length === 1) {
          return `${size} ${units[0]}`;
        }
        units.shift();
        return sizeToText(size / 1024, units);
      };
      return sizeToText(biteSize, units);
    },
    scoreText (score) {
      return numeral(score).format("0.000000")
    },
    scrollTo (target) {
      this.$SmoothScroll(
        document.querySelector(target).offsetTop,
        400,
        null,
        null,
        'y'
      )
    },
    truncate(text, length) {
      if (text) {
        return text.length <= length ? text : text.substr(0, length - 3) + "...";
      }
      return text;
    },
    toNumberString(text) {
      if (text) {
        return text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
      }
      return text;
    },
    gtmDataLayer (data) {
      const dataLayer = window.dataLayer || []
      dataLayer.push(data)
    },
    floor(value, precision) {
      return _floor(value, precision)
    },
    experiencedToolsLabel(tools, otherTools) {
      const constsTools = this.experiencedTools
      if (!constsTools) {
        return ''
      }
      const toolLabels = tools
          .map((tool) => {
            const constsTool = constsTools.find((item) => item.value === tool)
            if (constsTool) {
              return constsTool.label
            }
            return ''
          })
          .join('、')
      if (otherTools && otherTools.length > 0) {
        if (toolLabels && toolLabels.length > 0) {
          return `${toolLabels}、${otherTools}`
        }
        return `${otherTools}`
      }
      return toolLabels
    },
    experiencedDomainsLabel(domains, otherDomains) {
      const domainLabels = this.constsToText(domains, this.experiencedDomains)
      if (otherDomains && otherDomains.length > 0) {
        if (domainLabels && domainLabels.length > 0) {
          return `${domainLabels}、${otherDomains}`
        }
        return `${otherDomains}`
      }
      return domainLabels
    },
  },
};
